var map = {
	"./IMG_4803-min.webp": 2750,
	"./IMG_5213-min.webp": 6640,
	"./IMG_6926-min.webp": 6886,
	"./IMG_6927-min.webp": 2529,
	"./IMG_7735-min.webp": 3309,
	"./IMG_7776-min.webp": 4884,
	"./IMG_9169-min.webp": 4324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2806;